import ObservationsTable from "@/components/ListTable/ObservationsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { TAB_KEYS } from "@/constants/TabKeys";
import { OBSERVATIONS_FILTERS } from "@/entities/observations";
import { ListProvider } from "@/modules/list";

const TabObservation = ({ interventionId }) => {
  return (
    <ListProvider
      endpoint="observations"
      storageKey={STORAGE_KEYS.INTERVENTIONS_OBSERVATIONS}
      contextTabValue={TAB_KEYS.INTERVENTIONS_OBSERVATIONS}
      hiddenFilters={{
        [OBSERVATIONS_FILTERS.CATEGORY]: "defect",
        [OBSERVATIONS_FILTERS.SOURCE_INTERVENTION]: interventionId,
      }}
      defaultSort={["-risk_level", "state"]}
    >
      <ObservationsTable
        hiddenColumns={["source_intervention", "source_intervention.state"]}
      />
    </ListProvider>
  );
};

export default TabObservation;
